// src/utils/api.ts
import { API_ENDPOINTS } from "../config/api";
import authUtils from "./auth";

interface ApiRequestOptions extends RequestInit {
  requireAuth?: boolean;
}

export const apiRequest = async (
  url: string,
  options: ApiRequestOptions = {}
): Promise<Response> => {
  const { requireAuth = true, ...fetchOptions } = options;

  // 기본 헤더 설정
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(fetchOptions.headers as Record<string, string>),
  };

  // 인증이 필요한 경우 Authorization 헤더 추가
  if (requireAuth) {
    const accessToken = authUtils.getAccessToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }
  }

  const response = await fetch(url, {
    ...fetchOptions,
    headers,
  });

  // 401 Unauthorized 응답 시 토큰 삭제
  if (response.status === 401) {
    authUtils.clearTokens();
    // 로그인 페이지로 리다이렉트하거나 에러 처리
    window.location.href = "/login";
  }

  return response;
};

// 로그인 API 호출
export const login = async (username: string, password: string) => {
  const response = await apiRequest(API_ENDPOINTS.AUTH.LOGIN, {
    method: "POST",
    requireAuth: false, // 로그인은 인증 불필요
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error("로그인에 실패했습니다.");
  }

  const data = await response.json();

  if (data.success && data.data) {
    authUtils.setTokens({
      accessToken: data.data.accessToken,
      refreshToken: data.data.refreshToken,
    });
    return data;
  }

  throw new Error(data.message || "로그인에 실패했습니다.");
};

export default apiRequest;
